export const resourceConstants = {
	Resource_GetByFilter_Request: "RESOURCE_GET_ALL_STARTED",
	Resource_GetByFilter_Success: "RESOURCE_GET_ALL_COMPLETED",
	Resource_GetByFilter_Failure: "RESOURCE_GET_ALL_FAILED",

	Resource_GetActive_Request: "RESOURCE_GET_ACTIVE_STARTED",
	Resource_GetActive_Success: "RESOURCE_GET_ACTIVE_COMPLETED",
	Resource_GetActive_Failure: "RESOURCE_GET_ACTIVE_FAILED",

	ResourceSaveRequest: "RESOURCE_SAVE_STARTED",
	ResourceSaveSuccess: "RESOURCE_SAVE_COMPLETED",
	ResourceSaveFailure: "RESOURCE_SAVE_FAILED",

	ResourceDetailRequest: "RESOURCE_DETAIL_STARTED",
	ResourceDetailSuccess: "RESOURCE_DETAIL_COMPLETED",
	ResourceDetailFailure: "RESOURCE_DETAIL_FAILED",

	ResourceDeleteRequest: "RESOURCE_DELETE_STARTED",
	ResourceDeleteSuccess: "RESOURCE_DELETE_COMPLETED",
	ResourceDeleteFailure: "RESOURCE_DELETE_FAILED",

	ResourceStatusUpdateRequest: "RESOURCE_STATUS_UPDATE_STARTED",
	ResourceStatusUpdateSuccess: "RESOURCE_STATUS_UPDATE_COMPLETED",
	ResourceStatusUpdateFailure: "RESOURCE_STATUS_UPDATE_FAILED",
}
